import { memo } from 'react'
import SamsungSmartThingsAuthSuccess from '../success'

interface ConnectedProps {
  appName: string
  appLink?: string
}

const SamsungSmartThingsAuthConnected = memo(({ appName, appLink }: ConnectedProps) => {
  return (
    <SamsungSmartThingsAuthSuccess
      title="Connected successfully"
      appName={appName}
      appLink={appLink}
    />
  )
})

SamsungSmartThingsAuthConnected.displayName = 'SamsungSmartThingsAuthConnected'

export default SamsungSmartThingsAuthConnected
